export default __webpack_public_path__ + "static/clubCurtain-ac42305327ee15ea259ab24dcbcb7471.svg";